import {TrainingLevel, TrainingLevelRestControllerApiFactory,} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {COLOR_GRIS} from "../../../../components/layout/colors";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";

export const TrainingLevelListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<TrainingLevel> = {
		title: "Listado de formaciones ",
		onClick: "/app/admin/recruitment/traininglevel",
		headers: [
			{title: "Nombre"},
			{title: "Nivel"}
		],
		decorator: (bean: TrainingLevel) => (
			< >
				<TableCell style={{color: bean.dismissed ? COLOR_GRIS : ""}}>
					{bean.label}
				</TableCell>
				<TableCell>
					{bean.level}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(TrainingLevelRestControllerApiFactory);
			return ctrl.pageTrainingLevel(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};